module.exports = __webpack_public_path__ + "img/icon-fullscreen-open.258f8bbf.svg";